// src/js/modules/map.js

import $ from 'jquery';

async function loadGoogleMaps() {
    if (window.google?.maps) return;

    // eslint-disable-next-line consistent-return
    return new Promise((resolve, reject) => {
        const existingScript = document.querySelector(
            'script[src*="maps.googleapis.com/maps/api/js"]'
        );

        if (existingScript) {
            existingScript.addEventListener('load', () => resolve());
            existingScript.addEventListener('error', reject);
            return;
        }

        window.__initGoogleMaps = () => {
            resolve();
            delete window.__initGoogleMaps;
        };

        const script = document.createElement('script');
        script.src = 'https://maps.googleapis.com/maps/api/js?v=3&key=AIzaSyBVzA-8T7IiKYg8Q_lnnt9BnGME0olT0So&callback=__initGoogleMaps&libraries=marker';
        script.async = true;
        script.defer = true;

        script.onerror = reject;

        document.head.appendChild(script);
    });
}

async function initGoogleMap(o) {
    try {
        await loadGoogleMaps();

        // const googleMapsMarkerImage = '/typo3conf/ext/dorado/Resources/Public/img/icons/map_marker.png';

        const mapCenter = new google.maps.LatLng(o.latitude, o.longitude);
        const mapOptions = $.extend(true, o.options, {
            zoom: o.zoom || 5,
            center: mapCenter,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            scrollwheel: false,
            streetViewControl: false,
            zoomControlOptions: { position: google.maps.ControlPosition.TOP_RIGHT },
            mapId: 'DEMO_MAP_ID'
        });
        const map = new google.maps.Map(o.element, mapOptions);
        let infoWindow = null;
        let marker = null;

        marker = new google.maps.marker.AdvancedMarkerElement({
            position: mapCenter,
            map: map,
            title: o.title || ''
        });

        if (o.info) {
            infoWindow = new google.maps.InfoWindow({
                content: o.info
            });

            infoWindow.open(map, marker);
        } else {
            marker.setMap(map);
        }
    } catch (err) {
        console.error('Error loading the map:', err);
    }
}

window.initMap = initGoogleMap;

// export default mapModule;
